class ActionTypes {
  static CLEAR_ALL = 'CLEAR_ALL';
  static INITIALIZED = 'INITIALIZED';

  static USER_LOADING = 'USER_LOADING';
  static USER_ERROR = 'USER_ERROR';
  static DELETE_ACCOUNT_ERROR = 'DELETE_ACCOUNT_ERROR';
  static USER_LOGGED_IN = 'USER_LOGGED_IN';
  static USER_SETTINGS_UPDATED = 'USER_SETTINGS_UPDATED';
  static USER_DELETING_ACCOUNT = 'USER_DELETING_ACCOUNT';

  static USER_PAYMENT_CARD_LOADING = 'USER_PAYMENT_CARD_LOADING';
  static USER_PAYMENT_CARD_UPDATED = 'USER_PAYMENT_CARD_UPDATED';
  static USER_PAYMENT_CARD_FAILED = 'USER_PAYMENT_CARD_FAILED';
  static USER_PAYMENT_CARD_DELETED = 'USER_PAYMENT_CARD_DELETED';

  static USER_PAYMENT_HISTORY_LOADING = 'USER_PAYMENT_HISTORY_LOADING';
  static USER_PAYMENT_HISTORY_UPDATED = 'USER_PAYMENT_HISTORY_UPDATED';
  static USER_PAYMENT_HISTORY_FAILED = 'USER_PAYMENT_HISTORY_FAILED';

  static USER_UPCOMING_INVOICE_UPDATED = 'USER_UPCOMING_INVOICE_UPDATED';
  static USER_UPCOMING_INVOICE_LOADING = 'USER_UPCOMING_INVOICE_LOADING';
  static USER_UPCOMING_INVOICE_FAILED = 'USER_UPCOMING_INVOICE_FAILED';

  static SUBSCRIPTION_UPDATED = 'SUBSCRIPTION_UPDATED';
  static SUBSCRIPTION_LOADING = 'SUBSCRIPTION_LOADING';
  static SUBSCRIPTION_FAILED = 'SUBSCRIPTION_FAILED';
  static PREMIUM_CHECKOUT_SESSION = 'PREMIUM_CHECKOUT_SESSION';
  static CHECKOUT_SESSION_CLEARED = 'CHECKOUT_SESSION_CLEARED';
  static PREMIUM_CLIENT_SECRET = 'PREMIUM_CLIENT_SECRET';
  static PAYMENT_METHOD_ADDED = 'PAYMENT_METHOD_ADDED';

  static PROJECTS_LOADING = 'PROJECTS_LOADING';
  static PROJECTS_FAILED = 'PROJECTS_FAILED';
  static PROJECT_CREATED = 'PROJECT_CREATED';
  static PROJECT_DELETED = 'PROJECT_DELETED';
  static PROJECT_UPDATED = 'PROJECT_UPDATED';
  static CREATING_OR_UPDATING_PROJECT = 'CREATING_OR_UPDATING_PROJECT';
  static ADD_REMOVING_PROJECT_MEMBER = 'ADD_REMOVING_PROJECT_MEMBER';
  static REMOVE_REMOVING_PROJECT_MEMBER = 'REMOVE_REMOVING_PROJECT_MEMBER';

  static INVITING_TEAM = 'INVITING_TEAM';
  static ADD_UPDATING_INVITATION = 'ADD_UPDATING_INVITATION';
  static REMOVE_UPDATING_INVITATION = 'REMOVE_UPDATING_INVITATION';

  static TEAM_MEMBERS_LOADING = 'TEAM_MEMBERS_LOADING';
  static TEAM_MEMBERS_FAILED = 'TEAM_MEMBERS_FAILED';
  static TEAM_MEMBER_CREATED = 'TEAM_MEMBER_CREATED';
  static TEAM_MEMBER_DELETED = 'TEAM_MEMBER_DELETED';
  static TEAM_MEMBER_UPDATED = 'TEAM_MEMBER_UPDATED';
  static TEAM_MEMBER_UPDATING = 'TEAM_MEMBER_UPDATING';

  static PROJECTS_RECENT_ACTIVITY_LOADING = 'PROJECTS_RECENT_ACTIVITY_LOADING';
  static PROJECTS_RECENT_ACTIVITY_FAILED = 'PROJECTS_RECENT_ACTIVITY_FAILED';
  static PROJECTS_RECENT_ACTIVITY_CREATED = 'PROJECTS_RECENT_ACTIVITY_CREATED';
  static PROJECTS_RECENT_ACTIVITY_CLEAR = 'PROJECTS_RECENT_ACTIVITY_CLEAR';

  static PROJECTS_CONNECT_ACTIVITY_LOADING =
    'PROJECTS_CONNECT_ACTIVITY_LOADING';
  static PROJECTS_CONNECT_ACTIVITY_FAILED = 'PROJECTS_CONNECT_ACTIVITY_FAILED';
  static PROJECTS_CONNECT_ACTIVITY_CREATED =
    'PROJECTS_CONNECT_ACTIVITY_CREATED';
  static PROJECTS_CONNECT_ACTIVITY_CLEAR = 'PROJECTS_CONNECT_ACTIVITY_CLEAR';
  static PROJECTS_CONNECT_ACTIVITY_HAS_MORE =
    'PROJECTS_CONNECT_ACTIVITY_HAS_MORE';
  static PROJECTS_CONNECT_ACTIVITY_LOADING_MORE =
    'PROJECTS_CONNECT_ACTIVITY_LOADING_MORE';

  static PROJECT_DETAILS_WORK_LOGS_FETCHED =
    'PROJECT_DETAILS_WORK_LOGS_FETCHED';
  static PROJECT_DETAILS_WORK_LOGS_CLEAR = 'PROJECT_DETAILS_WORK_LOGS_CLEAR';

  static EMPLOYEE_DETAILS_WORK_LOGS_FETCHED =
    'PROJECT_DETAILS_WORK_LOGS_FETCHED';
  static EMPLOYEE_DETAILS_WORK_LOGS_CLEAR = 'PROJECT_DETAILS_WORK_LOGS_CLEAR';

  static SHOW_DIALOG = 'SHOW_DIALOG';
  static UPDATE_AVAILABLE = 'UPDATE_AVAILABLE';
}

export default ActionTypes;



// WEBPACK FOOTER //
// ./src/common/ActionTypes.js